
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinlohgaon() {



  const cardData =
  {
    keyword: 'Taxi Service in Lohegaon',
    heading: 'AB Ghule Cabs: Taxi Service in Lohegaon',
    headingDescription: 'Looking for a dependable taxi service in Lohegaon, Pune? AB Ghule Cabs offers reliable, comfortable, and affordable cab services to meet all your travel needs. Whether it’s local commutes, airport transfers, or outstation trips, we ensure a hassle-free travel experience tailored just for you.',

    top: 'Our Taxi Services in Lohegaon',

    "topPlaces": [
        {
          title: "Pune Airport (Lohegaon Airport)",
          description: "The major gateway to Pune, the airport itself is a hub of activity. While not a typical tourist spot, it offers a bustling atmosphere and access to nearby attractions."
        },
        {
          title: "Aga Khan Palace",
          description: "A historical landmark located about 15 km from Lohegaon, this grand palace is known for its architectural beauty and historical significance, particularly in the Indian freedom struggle."
        },
        {
          title: "Khadakwasla Dam",
          description: "Situated near Lohegaon, this serene location offers picturesque views and is ideal for a peaceful picnic or a boat ride."
        },
        {
          title: "Shinde Chhatri",
          description: "This historical monument dedicated to the Maratha warrior, Mahadji Shinde, is located nearby and offers a glimpse into Maratha history and architecture."
        },
        {
          title: "ISKCON NVCC Temple",
          description: "A beautiful temple dedicated to Lord Krishna, located about 10-15 minutes from Lohegaon. It's a peaceful place for spiritual reflection."
        },
        {
          title: "Pataleshwar Cave Temple",
          description: "An ancient rock-cut temple situated around 12 km from Lohegaon, this historical site offers a glimpse of Pune's ancient culture and architecture."
        },
        {
          title: "Nandi Hills",
          description: "Located a little further out, Nandi Hills is a tranquil getaway, perfect for nature lovers and those looking to explore Pune’s scenic landscapes."
        },
        {
          title: "Sundarban Garden",
          description: "A well-maintained garden perfect for family picnics, relaxation, and leisurely strolls, located nearby Lohegaon."
        },
        {
          title: "Raja Dinkar Kelkar Museum",
          description: "Situated around 15 km away, this museum has a rich collection of artifacts and exhibits showcasing India’s cultural heritage, including musical instruments, sculptures, and paintings."
        },
        {
          title: "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
          description: "One of the largest Japanese-style gardens in India, located a little outside Lohegaon. It’s perfect for leisurely walks, nature lovers, and photography."
        }
      ],


      services: [
        {
          "name": "Taxi Service in Lohegaon",
          description: "At AB Ghule Cabs, we offer a reliable and convenient taxi service in Lohegaon. Whether you're traveling for business, leisure, or need transportation to the airport, we provide a range of affordable and comfortable taxis to suit your needs. Our fleet includes sedans, SUVs, and luxury cars, ensuring that you travel in comfort and style. We are committed to offering a seamless travel experience with timely, professional service."
        },
        {
          "name": "Taxi Booking in Lohegaon",
          description: "Looking for a taxi in Lohegaon? Our taxi booking service is quick and easy. Whether you need a ride for a short trip or an outstation journey, you can book your Lohegaon taxi with just a few clicks. We offer door-to-door service, ensuring maximum convenience. Our easy-to-use platform ensures a smooth booking process, saving you time and effort."
        },
        {
          "name": "Reliable Taxi in Lohegaon",
          description: "Our reliable taxi services in Lohegaon are known for punctuality and safety. Whether you are heading to the airport, going for a local sightseeing tour, or traveling out of Pune, we ensure you have a smooth and comfortable ride. Our experienced drivers are committed to providing a safe and pleasant experience, making sure you reach your destination without delay."
        },
        {
          "name": "Affordable Taxi in Lohegaon",
          description: "Looking for affordable taxi services in Lohegaon? We provide budget-friendly taxi options without compromising on service quality. Whether it's a short trip or a longer journey, our prices are competitive and transparent. We offer a variety of vehicles, so you can choose the right option that fits your budget, ensuring value for your money."
        },
        {
          "name": "24/7 Taxi Service in Lohegaon",
          description: "We understand that transportation needs can arise at any time, which is why we offer 24/7 taxi service in Lohegaon. Whether you need a ride at dawn or late at night, we are always available to serve you. Our dedicated service ensures that you can rely on us no matter the time, offering flexibility and convenience whenever you need a ride."
        },
        {
          "name": "Airport Taxi Service in Lohegaon",
          description: "Located close to Pune Airport, we offer efficient and timely airport taxi services from Lohegaon. Whether you're arriving or departing from the airport, our experienced drivers ensure you get to your destination comfortably and on time. Our airport taxi service is designed to ensure you have a stress-free and reliable journey to or from the airport."
        },
        {
          "name": "Luxury Taxi Service in Lohegaon",
          description: "Travel in style with our luxury taxi services in Lohegaon. Whether you're going for a special occasion or simply want to experience a more comfortable journey, our luxury cars offer the perfect blend of comfort, elegance, and top-notch service. Our premium vehicles are equipped with the latest amenities to make your ride luxurious and enjoyable."
        },
        {
          "name": "Taxi Near Lohegaon",
          description: "Looking for a taxi near Lohegaon? Our taxis are available for immediate booking near your location, ensuring quick and easy access to transportation when you need it most. Our reliable fleet is always nearby, ready to provide you with efficient service whether you're going for a short trip or a longer journey."
        },
        {
          "name": "Cheapest Taxi Service in Lohegaon",
          description: "Need a cheap taxi in Lohegaon? We offer the most cost-effective taxi services in the area. Despite our affordable rates, we maintain a high standard of service, ensuring your ride is smooth, safe, and comfortable. With transparent pricing and no hidden charges, you can rely on us for budget-friendly, quality taxi service."
        },
        {
          "name": "Pune Airport to Shirdi Cab",
          description: "If you're planning to visit Shirdi from Pune Airport, we offer convenient and affordable Pune Airport to Shirdi cab services. Our well-maintained vehicles and professional drivers will ensure that you reach your destination comfortably and on time. We provide a hassle-free experience for your journey, making it easy and stress-free."
        },
        {
          "name": "Pune Airport Cab Service",
          description: "We offer reliable Pune Airport cab services, with pick-ups and drop-offs at your convenience. Our taxis are available for both local and outstation trips from Pune Airport. Whether you're heading to a meeting or catching a flight, our drivers ensure you arrive on time and travel comfortably."
        },
        {
          "name": "Lohegaon Pune Airport Cab Service",
          description: "For passengers staying in or near Lohegaon, our Lohegaon to Pune Airport cab service ensures timely pickups and drop-offs. Whether you need a ride to the airport or from it, we provide a hassle-free, comfortable journey. Our drivers are well-versed with the best routes, ensuring punctuality and a smooth ride."
        },
        {
          "name": "Taxi Service in Lohegaon Airport",
          description: "For those specifically needing a taxi service in Lohegaon Airport, we offer dedicated pick-up and drop-off services right at the airport. Our drivers are well-acquainted with the airport's layout, ensuring efficient service. With us, your airport transportation is seamless and timely, offering you the best travel experience."
        },
        {
          "name": "Pune Airport Pickup Point Cab",
          description: "We offer convenient Pune Airport pickup point cabs, ensuring you're picked up from the right location at the airport. Whether you’re arriving or departing, our drivers will be waiting for you, offering prompt and courteous service. We ensure a smooth, quick pickup to get your journey started without delay."
        },
        {
          "name": "Pune Airport to Lonavala Cab",
          description: "Planning a trip from Pune Airport to Lonavala? We offer convenient, comfortable, and affordable cabs for the journey. Our drivers know the best routes, ensuring a smooth trip to Lonavala. Whether for a leisure trip or business, we provide a relaxed and timely service."
        },
        {
          "name": "Pune Airport to Nashik Cab",
          description: "For those heading to Nashik from Pune Airport, we offer reliable cab services with experienced drivers. Our cabs ensure comfort and safety on your way to Nashik. We ensure that your journey is smooth, safe, and on time, so you can enjoy the ride."
        },
        {
          "name": "Pune Airport to Shirdi Cab Fare",
          description: "The Pune Airport to Shirdi cab fare is competitive and reasonable. We offer transparent pricing, so you know exactly what to expect. The journey is comfortable and hassle-free with our professional drivers, ensuring a pleasant and affordable travel experience."
        },
        {
          "name": "Pune Airport to Kolhapur Cab",
          description: "Traveling from Pune Airport to Kolhapur? We offer Pune Airport to Kolhapur cab services with affordable rates and experienced drivers, ensuring a comfortable journey. Our reliable service guarantees a safe and smooth ride to Kolhapur, no matter the purpose of your trip."
        },
        {
          "name": "Pune Airport to Aurangabad Cab",
          description: "If you’re traveling from Pune Airport to Aurangabad, our Pune Airport to Aurangabad cab service offers convenience and comfort with our well-maintained cabs and reliable drivers. We provide a pleasant journey with timely arrivals and competitive fares."
        },
        {
          "name": "Pune Airport to Shirdi One-Way Cab",
          description: "We offer one-way cabs from Pune Airport to Shirdi for those who are traveling to Shirdi without a return. Enjoy the comfort and convenience of a one-way journey with our well-maintained cars. Our one-way service offers you a cost-effective and comfortable travel option to Shirdi."
        },
        {
          "name": "Taxi Service in Lohegaon Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Taxi Service in Lohegaon. Our customer support team is always available to assist you with your bookings and queries. We ensure a smooth and enjoyable ride for all our customers, providing reliable service that exceeds your expectations."
        }
      ],

      tableData: [
        ["Lohegaon taxi service", "-Taxi booking Lohegaon"],
        ["Taxi in Lohegaon", "-Cab service Lohegaon"],
        ["Lohegaon cab booking", "-Reliable taxi Lohegaon"],
        ["Affordable taxi Lohegaon", "-24/7 taxi service Lohegaon"],
        ["Airport taxi Lohegaon", "-Luxury taxi Lohegaon"],
        ["Taxi near Lohegaon", "-Cheapest taxi service in lohegaon"],
        ["Pune Airport to Shirdi cab", "-Pune airport cab service"],
        ["Lohegaon Pune Airport Cab Service", "-Taxi service in lohegaon airport"],
        ["Pune airport pickup point cab", "-Pune airport to lonavala cab"],
        ["Pune airport to nashik cab", "-Pune airport to shirdi cab fare"],
        ["Pune airport to kolhapur cab", "-Pune airport to aurangabad cab"],
        ["Pune airport to shirdi one way cab", "-Lohegaon pune airport cab service"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Timely Service",
          WhyChoosedescription: "At AB Ghule Cabs, we provide punctual and dependable taxi services in Lohegaon. Whether you need a ride to the airport, a business meeting, or a local trip, we ensure you reach your destination on time."
        },
        {
          WhyChooseheading: "Affordable and Transparent Pricing",
          WhyChoosedescription: "We offer competitive and transparent pricing with no hidden charges. You will always know the exact fare for your journey before you travel, ensuring a hassle-free experience."
        },
        {
          WhyChooseheading: "Variety of Vehicles to Choose From",
          WhyChoosedescription: "We offer a range of vehicles, including budget-friendly sedans, SUVs, and luxury cars. Whether you're traveling solo, with family, or for business, we have the right vehicle for you in Lohegaon."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "Our drivers are experienced, courteous, and well-versed with the roads of Lohegaon and Pune. They ensure a safe and comfortable ride, maintaining professionalism at all times."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "Our taxi service in Lohegaon operates 24/7, providing you with flexibility to book a ride at any time of the day or night. Our customer service is always available to assist you with bookings or any inquiries."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking a taxi in Lohegaon is quick and easy. You can either book online via our website or mobile app, or contact our customer service team to book your ride instantly."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "All our vehicles are well-maintained and cleaned regularly to ensure a smooth, comfortable, and safe ride for every customer."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi in Lohegaon?',
      answer: 'You can book a taxi in Lohegaon through our website, mobile app, or by calling our customer service team.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a taxi ride within Lohegaon?',
      answer: 'The fare for a short ride within Lohegaon starts from ₹400 for a sedan.',
    },
    {
      id: 'FAQ3',
      question: 'Can I book a taxi for an airport transfer from Lohegaon?',
      answer: 'Yes, we offer airport transfer services. The fare from Lohegaon to Pune Airport typically starts at ₹600 for a sedan.',
    },
    {
      id: 'FAQ4',
      question: 'Are the vehicles in good condition?',
      answer: 'Yes, all our vehicles are regularly maintained, cleaned, and inspected to ensure a comfortable and safe ride.',
    },
    {
      id: 'FAQ5',
      question: 'How do I pay for my taxi ride?',
      answer: 'You can pay using cash, credit/debit cards, or via online payment options through our mobile app.',
    },
    {
      id: 'FAQ6',
      question: 'Can I book a taxi for an intercity ride?',
      answer: 'Yes, we offer intercity taxi services from Lohegaon to various destinations, including Mumbai, Lonavala, and more.',
    },
    {
      id: 'FAQ7',
      question: 'Are your drivers experienced?',
      answer: 'Yes, our drivers are highly experienced, trained, and background-checked to ensure your safety during the ride.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Aditya Patel',
      feedback: 'AB Ghule Cabs has been my go-to taxi service in Lohegaon. Their punctuality, cleanliness, and friendly drivers have always impressed me. I rely on them for both business and personal trips.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Richa Mehta',
      feedback: 'I had a wonderful experience booking a taxi with AB Ghule Cabs from Lohegaon to Pune Airport. The driver was professional, and I reached the airport on time. I highly recommend their service for airport transfers.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Lohegaon | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book a reliable and affordable taxi service in Lohegaon with AB Ghule Cabs. 24/7 taxi service for local and outstation trips, including Pune Airport pickup. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Lohegaon taxi service, Taxi booking Lohegaon, Taxi in Lohegaon, Cab service Lohegaon, Lohegaon cab booking, Reliable taxi Lohegaon, Affordable taxi Lohegaon, 24/7 taxi service Lohegaon, Airport taxi Lohegaon, Luxury taxi Lohegaon, Taxi near Lohegaon, Cheapest taxi service in Lohegaon, Pune Airport to Shirdi cab, Pune airport cab service, Lohegaon Pune Airport Cab Service, taxi service in Lohegaon airport, Pune airport pickup point cab, Pune airport to Lonavala cab, Pune airport to Nashik cab, Pune airport to Shirdi cab fare, Pune airport to Kolhapur cab, Pune airport to Aurangabad cab, Pune airport to Shirdi one way cab, Lohegaon Pune airport cab service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Lohegaon | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book a reliable and affordable taxi service in Lohegaon with AB Ghule Cabs. 24/7 taxi service for local and outstation trips, including Pune Airport pickup. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/taxi-service-lohegaon.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/taxi-service-lohegaon" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Taxi Service in Lohegaon",
        description: "Book a reliable and affordable taxi service in Lohegaon with AB Ghule Cabs. 24/7 taxi service for local and outstation trips, including Pune Airport pickup. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Lohegaon, Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411032",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/taxi-service-lohegaon",
        "logo": "https://abghulecabs.com/images/taxi-service-lohegaon.jpg",
        "image": "https://abghulecabs.com/images/taxi-service-lohegaon.jpg",
        "priceRange": "₹1000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/taxi-service-lohegaon",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rahul K"
            },
            "datePublished": "2024-10-15",
            "reviewBody": "Affordable and reliable taxi service for airport pickups and outstation trips. Highly recommend AB Ghule Cabs in Lohegaon!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-08-25",
            "reviewBody": "The best taxi service I have used in Lohegaon! Comfortable ride and punctual drivers. Will definitely use it again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Lohegaon and Surrounding Areas Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5827",
            "longitude": "73.9122"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/taxi-service-lohegaon"
        },
        "keywords": "Lohegaon taxi service, Taxi booking Lohegaon, Taxi in Lohegaon, Cab service Lohegaon, Lohegaon cab booking, Reliable taxi Lohegaon, Affordable taxi Lohegaon, 24/7 taxi service Lohegaon, Airport taxi Lohegaon, Luxury taxi Lohegaon, Taxi near Lohegaon, Cheapest taxi service in Lohegaon, Pune Airport to Shirdi cab, Pune airport cab service, Lohegaon Pune Airport Cab Service, taxi service in Lohegaon airport, Pune airport pickup point cab, Pune airport to Lonavala cab, Pune airport to Nashik cab, Pune airport to Shirdi cab fare, Pune airport to Kolhapur cab, Pune airport to Aurangabad cab, Pune airport to Shirdi one way cab, Lohegaon Pune airport cab service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/58.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Taxiserviceinlohgaon;